import React, { Component } from 'react';
import central, { FormatoData, FormatoMoeda } from '../api/Central';
import Resultado from '../api/Resultado';
import Alert from '../components/Alert';
import Navegacao from '../components/Navegacao';
import StatusBoleto from '../components/StatusBoleto';

class DetalheBoleto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boleto: null,
            copiado: false,
            pixcopiado: false
        }
    }
    componentDidMount() {
        central.request("GET", "/boletos/" + this.props.match.params.id,
            null,
            (payload) => {
                var boletos = new Resultado(payload);
                this.setState({ boleto: boletos.rows[0] });
            },
            () => { });

    }
    pdf() {
        window.open(central.urlCentral + "/central/api/boletos/" + this.state.boleto.id + "/visualizar", "_blank");
    }
    copiar() {
        const cb = this.state.boleto.codigobarras.replace(/\D/g, '');
        console.log("copiar: ", cb)
        navigator.clipboard.writeText(cb).then(() => {
            this.setState({ copiado: true })
        });

    }
    copiarpix() {
        const cb = this.state.boleto.qrcodedinamicopix;
        console.log("copiar: ", cb)
        navigator.clipboard.writeText(cb).then(() => {
            this.setState({ pixcopiado: true })
        });

    }
    render() {
        return (
            <section className="container">
                {this.state.boleto && (
                    <React.Fragment>
                        <Navegacao link="/boletos" titulo={"Boleto " + this.state.boleto.id} />
                        <section>
                            <table>
                                <tbody>
                                    <tr><td>Status:</td><td><StatusBoleto boleto={this.state.boleto} /></td></tr>
                                    <tr><td>Valor:</td><td>{FormatoMoeda.format(this.state.boleto.valor)}</td></tr>
                                    <tr><td>Vencimento:</td><td>{FormatoData.format(this.state.boleto.vencimento)}</td></tr>
                                    {this.state.boleto.codigobarras &&
                                        <>
                                            <tr>
                                                <td>Cód de barras:</td>
                                                <td>{this.state.boleto.codigobarras}<br />
                                                    <button onClick={this.copiar.bind(this)}>Copiar código</button>
                                                    {this.state.copiado &&
                                                        <Alert type="info"><b>Pronto.</b> Agora basta ir até o app do banco e colar. </Alert>}
                                                </td>
                                            </tr>
                                        </>
                                    }
                                    {this.state.boleto.qrcodedinamicopix &&
                                        <>
                                            <tr>
                                                <td>Pix copia e cola:</td>
                                                <td><button onClick={this.copiarpix.bind(this)}>Copiar código para pagamento Pix</button>
                                                    {this.state.pixcopiado &&
                                                        <Alert type="info"><b>Pronto. Código copiado.</b> Agora basta ir até o app do banco, usar a função "pix copia e cola" e colar o código. </Alert>}
                                                </td>
                                            </tr>
                                        </>
                                    }
                                    <tr><td>Descrição:</td><td>{this.state.boleto.descricao}</td></tr>
                                </tbody>
                            </table>
                            <button onClick={this.pdf.bind(this)}>Visualizar Boleto</button>
                        </section>
                    </React.Fragment>
                )}
            </section>
        );
    }
}

export default DetalheBoleto;